import React from 'react';
import { t } from '../lib/i18n';

const DAY = 86400000;
const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x.getTime(); };

// Returns { key, label, cls } or null for catalogs that are neither about to expire nor upcoming.
export const urgency = (deal, now = new Date()) => {
  const today = startOfDay(now);
  const start = deal.date_start ? startOfDay(`${deal.date_start}T00:00:00`) : null;
  const end = deal.date_end ? startOfDay(`${deal.date_end}T00:00:00`) : null;
  if (start && start > today) return { key: 'soon', label: t('Bientôt disponible'), cls: 'bg-white text-black' };
  if (end == null) return null;
  const days = Math.round((end - today) / DAY);
  if (days < 0) return { key: 'expired', label: t('Expiré'), cls: 'bg-gray-600 text-white' };
  if (days === 0) return { key: 'today', label: t('Expire aujourd’hui'), cls: 'bg-[#E50914] text-white' };
  if (days === 1) return { key: 'tomorrow', label: t('Expire demain'), cls: 'bg-orange-500 text-white' };
  if (days <= 3) return { key: 'days', label: `${t('Se termine dans')} ${days} ${t('jours')}`, cls: 'bg-amber-400 text-black' };
  return null;
};

export const isNewCatalog = (deal, now = Date.now()) => deal.created_at && now - new Date(deal.created_at).getTime() < 7 * DAY;

const UrgencyBadge = ({ deal, className = '', size = 'sm' }) => {
  const u = urgency(deal);
  if (!u) return null;
  return (
    <span data-testid="urgency-badge" data-urgency={u.key}
      className={`shine inline-flex items-center rounded-full font-bold uppercase tracking-wider shadow-lg ${size === 'lg' ? 'text-xs px-3 py-1.5' : 'text-[10px] px-2.5 py-1'} ${u.cls} ${className}`}>
      {u.label}
    </span>
  );
};

export default UrgencyBadge;
